import { useQuery } from "@tanstack/react-query";
import { get } from "lib/http";
import { CustomerFileTag } from "types/customer-file-tag";

export const useCustomerFileTags = () => {
  const fetchCustomerFileTag = async (): Promise<CustomerFileTag[]> => {
    return await get(
      `operations-data-provider/cobble-flow-read-api-proxy/murfy_erp_customerfiletag?order=color,text.asc`
    );
  };

  const { data, isLoading, isError } = useQuery<CustomerFileTag[]>(["customer-file-tags"], async () =>
    fetchCustomerFileTag()
  );
  return { tags: data, isLoading, isError };
};
